
/**
 * Utility functions for card validation
 */

/**
 * Check if card number is valid using the Luhn algorithm
 */
export const isValidCardNumber = (cardNumber: string): boolean => {
  // Remove any spaces or dashes
  const digits = cardNumber.replace(/\D/g, '');
  
  if (digits.length < 13 || digits.length > 19) {
    return false;
  }
  
  // Implement Luhn algorithm (basic version)
  let sum = 0;
  let shouldDouble = false;
  
  // Loop through digits from right to left
  for (let i = digits.length - 1; i >= 0; i--) {
    let digit = parseInt(digits.charAt(i));
    
    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }
    
    sum += digit;
    shouldDouble = !shouldDouble;
  }
  
  return sum % 10 === 0;
};

/**
 * Determine card brand based on card number
 */
export const getCardBrand = (cardNumber: string): string => {
  const firstDigit = cardNumber.charAt(0);
  const firstTwoDigits = Number(cardNumber.substring(0, 2));
  
  if (firstDigit === '4') return 'visa';
  if (firstTwoDigits >= 51 && firstTwoDigits <= 55) return 'mastercard';
  if (firstTwoDigits === 34 || firstTwoDigits === 37) return 'amex';
  if (firstTwoDigits === 62) return 'unionpay';
  
  return 'unknown';
};
